export const DEFAULT_LOCALE = 'ru-RU';

export const SUPPORT_LOCALES = [
  {
    name: 'Russian',
    title: 'Ru',
    key: 'ru',
    code: 'ru-RU',
    urlPrefix: null,
    translationKey: 'ru'
  },
  {
    name: 'Ukranian',
    title: 'UA',
    key: 'uk',
    code: 'ua-UA',
    urlPrefix: 'ua',
    translationKey: 'ua'
  }
];

// Backend (/me.locale, PATCH /auth/me/locale) speaks translationKey ('ua' | 'ru'),
// while vue-i18n-manager ($setLanguage, currentLanguage) works with code ('ua-UA' | 'ru-RU').
export const codeByTranslationKey = (translationKey) =>
  SUPPORT_LOCALES.find((item) => item.translationKey === translationKey)?.code || null;

export const translationKeyByCode = (code) =>
  SUPPORT_LOCALES.find((item) => item.code === code)?.translationKey || null;
